import { ChakraProvider } from "@chakra-ui/react"
import { ThemeProvider } from "next-themes"
import React from "react"
import ReactDOM from "react-dom/client"
import { Provider } from "react-redux"
import { store } from "./store/store"
import customSystem from "./theme"
import App from "./App"
import AppToaster from "./components/ui/Toaster"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ChakraProvider value={customSystem}>
        <ThemeProvider attribute="class" disableTransitionOnChange>
          <App />
          <AppToaster />
        </ThemeProvider>
      </ChakraProvider>
    </Provider>
  </React.StrictMode>,
)
